'use client'
import React, { FC } from 'react'
import { Heading, HStack, VStack } from '@chakra-ui/react'
import { ScrollDragContainer } from '@/app/[locale]/(public)/components/ScrollDragContainer'
import { RealEstateLightDTO } from '@/core/real-estate/typings'
import { useRouter } from '@/i18n/navigation'
import RealEstateItemVertical from '@/app/[locale]/(public)/components/RealEstateItemVertical'
import { gtmEvent, RealestateDetailOtherRealestateClick } from '@/utils/gtm'
import { useSearchParams } from 'next/navigation'
import { useClientLocale } from '@/hooks/use-locale-config'

interface RealEstateInAreaProps {
  data: RealEstateLightDTO[]
}

const RealEstateInArea: FC<RealEstateInAreaProps> = ({ data }) => {
  const locale = useClientLocale()
  const searchParams = useSearchParams()
  const router = useRouter()

  const handleItemClick = (item: RealEstateLightDTO) => {
    gtmEvent<RealestateDetailOtherRealestateClick>({
      name: 'realestate_detail_other_realestate_click',
      locale,
      params: {
        realestate_id: item.id
      }
    })
    const searchQueries = searchParams.toString()
    router.push(`/propiedades/${item.slug}${searchQueries ? '?' + searchQueries : ''}`)
  }

  if (!data?.length) {
    return null
  }

  return (
    <VStack w="full" overflow="hidden" py={{ base: 4, md: 6 }} mx="auto" maxW="container.xl">
      <Heading fontSize={{ base: '2xl', md: '5xl' }} w="full">
        Otras propiedades en el área
      </Heading>
      <ScrollDragContainer w="full">
        <HStack spacing={4} alignItems="stretch" w="full">
          {data.map((item) => (
            <RealEstateItemVertical
              maxW={'300px'}
              minW={'300px'}
              w={'300px'}
              h="auto"
              key={item.id}
              item={item}
              onItemClick={handleItemClick}
            />
          ))}
        </HStack>
      </ScrollDragContainer>
    </VStack>
  )
}

export default RealEstateInArea
